"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _IconButton = _interopRequireDefault(require("eventbrite_design_system/iconButton/IconButton"));

var _CrossChunky = _interopRequireDefault(require("eventbrite_design_system/iconography/icons/CrossChunky"));

var _FollowLoadingCard = _interopRequireDefault(require("./FollowLoadingCard"));

var _FollowBlock = require("./FollowBlock");

var _constants = require("../constants");

require("./FollowCard.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SampleEventAttachment = function SampleEventAttachment(_ref) {
  var startDate = _ref.startDate,
      name = _ref.name;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "follow-page__organizer-card__sample-event eds-l-pad-hor-6 eds-l-pad-vert-4 eds-text-weight--heavy"
  }, startDate && /*#__PURE__*/_react.default.createElement("div", {
    className: "follow-page__organizer-card__sample-event-date"
  }, startDate), /*#__PURE__*/_react.default.createElement("div", {
    className: "follow-page__organizer-card__sample-event-name"
  }, name.toLocaleUpperCase()));
};

var isInfoReady = function isInfoReady(isFollowing, organizerProfileUrl) {
  return typeof isFollowing === 'boolean' && organizerProfileUrl;
};

var FollowCard = /*#__PURE__*/function (_Component) {
  _inherits(FollowCard, _Component);

  var _super = _createSuper(FollowCard);

  function FollowCard(props) {
    var _this;

    _classCallCheck(this, FollowCard);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_handleFollow", function () {
      var _this$props = _this.props,
          organizerId = _this$props.organizerId,
          onClose = _this$props.onClose,
          onFollow = _this$props.onFollow,
          isHiddenWhenFollowed = _this$props.isHiddenWhenFollowed;
      onFollow();

      if (isHiddenWhenFollowed && onClose) {
        _this._followTimeout = setTimeout(function () {
          onClose({
            organizerId: organizerId
          });
        }, _constants.CARD_CLOSE_DELAY);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_handleUnFollow", function () {
      _this.props.onUnFollow();
    });

    _defineProperty(_assertThisInitialized(_this), "_handleClose", function () {
      var _this$props2 = _this.props,
          onClose = _this$props2.onClose,
          onExcludeOrganizer = _this$props2.onExcludeOrganizer,
          organizerId = _this$props2.organizerId;

      if (onExcludeOrganizer) {
        onExcludeOrganizer(organizerId);
      }

      _this.setState({
        isClosed: true
      });

      if (onClose) {
        _this._closeTimeout = setTimeout(function () {
          onClose({
            organizerId: organizerId
          });
        }, _constants.CARD_CLOSE_DELAY);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_handleOnClick", function () {
      var _this$props3 = _this.props,
          organizerId = _this$props3.organizerId,
          onViewOrganizer = _this$props3.onViewOrganizer;

      if (onViewOrganizer) {
        onViewOrganizer(organizerId);
      }
    });

    _this.state = {
      isClosed: false
    };
    return _this;
  }

  _createClass(FollowCard, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._followTimeout) {
        clearTimeout(this._followTimeout);
        this._followTimeout = null;
      }

      if (this._closeTimeout) {
        clearTimeout(this._closeTimeout);
        this._closeTimeout = null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          organizerId = _this$props4.organizerId,
          imageUrl = _this$props4.imageUrl,
          organizerProfileUrl = _this$props4.organizerProfileUrl,
          organizerName = _this$props4.organizerName,
          style = _this$props4.style,
          sampleEvent = _this$props4.sampleEvent,
          isHiddenWhenFollowed = _this$props4.isHiddenWhenFollowed,
          isClosable = _this$props4.isClosable,
          numUpcomingEvents = _this$props4.numUpcomingEvents,
          numFollowers = _this$props4.numFollowers,
          customDataPoint = _this$props4.customDataPoint,
          shouldHideDefaultDataPoint = _this$props4.shouldHideDefaultDataPoint,
          size = _this$props4.size,
          isBackgroundHidden = _this$props4.isBackgroundHidden,
          isFollowing = _this$props4.isFollowing,
          isSolitary = _this$props4.isSolitary;
      var isClosed = this.state.isClosed;
      var shouldBeHidden = isHiddenWhenFollowed ? isFollowing || isClosed : false;
      var shouldBeFilteredOut = !organizerName || shouldBeHidden && !isClosed;
      var containerClasses = (0, _classnames.default)({
        'organizer-card__container': true,
        'eds-fx--fade-out': shouldBeHidden
      });

      if (!isInfoReady(isFollowing, organizerProfileUrl)) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: containerClasses
        }, /*#__PURE__*/_react.default.createElement(_FollowLoadingCard.default, {
          style: style,
          isBackgroundHidden: isBackgroundHidden
        }));
      }

      if (shouldBeFilteredOut) {
        return null;
      }

      var organizerCardClasses = (0, _classnames.default)('organizer-card', {
        'organizer-card--no-bg': isBackgroundHidden,
        'eds-bg-color--background': !isBackgroundHidden,
        'organizer-card--grid': style === _constants.GRID_TYPE,
        'organizer-card--list': style === _constants.LIST_TYPE,
        'organizer-card--list__mini': size === _constants.MINI_SIZE && style === _constants.LIST_TYPE,
        'organizer-card-list__standard': size === _constants.STANDARD_SIZE && style === _constants.LIST_TYPE
      });
      var blockSize = style === _constants.LIST_TYPE ? size : _constants.STANDARD_SIZE;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: containerClasses
      }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("section", {
        className: organizerCardClasses
      }, /*#__PURE__*/_react.default.createElement(_FollowBlock.FollowBlock, {
        onHandleOnClick: this._handleOnClick,
        organizerProfileUrl: organizerProfileUrl,
        organizerName: organizerName,
        imageUrl: imageUrl,
        organizerId: organizerId,
        isFollowing: isFollowing,
        onFollow: this._handleFollow,
        onUnFollow: this._handleUnFollow,
        numUpcomingEvents: numUpcomingEvents,
        numFollowers: numFollowers,
        customDataPoint: customDataPoint,
        isSolitary: isSolitary,
        shouldHideDefaultDataPoint: shouldHideDefaultDataPoint,
        size: blockSize
      }), isClosable && /*#__PURE__*/_react.default.createElement("div", {
        className: "organizer-card__underlay"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "organizer-card__close-btn"
      }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
        iconType: /*#__PURE__*/_react.default.createElement(_CrossChunky.default, null),
        iconColor: "grey-600",
        title: _constants.REMOVE_ORGANIZER_CARD_TEXT,
        onClick: this._handleClose
      })))), sampleEvent && /*#__PURE__*/_react.default.createElement(SampleEventAttachment, {
        startDate: sampleEvent.formattedDate,
        name: sampleEvent.name
      })));
    }
  }]);

  return FollowCard;
}(_react.Component);

exports.default = FollowCard;

_defineProperty(FollowCard, "propTypes", {
  /*
   * ID of the organizer this card represents
   */
  organizerId: _propTypes.default.string.isRequired,

  /*
   * Style of Card to be rendered 'grid' or 'list'
   */
  style: _propTypes.default.oneOf(_constants.CARD_TYPES).isRequired,

  /*
   * Size of card 'mini' or 'standard'
   */
  size: _propTypes.default.oneOf(_constants.CARD_SIZES).isRequired,

  /*
   * Callback for when user clicks to follow
   */
  onFollow: _propTypes.default.func.isRequired,

  /*
   * Callback for when user clicks to unfollow
   */
  onUnFollow: _propTypes.default.func.isRequired,

  /*
   * Name of the organizer
   */
  organizerName: _propTypes.default.string,

  /*
   * URL to organizer profile
   */
  organizerProfileUrl: _propTypes.default.string,

  /*
   * Whether user is currently following organizer or not
   */
  isFollowing: _propTypes.default.bool,

  /*
   * Prop configuring whether or not the card
   * will display background color, border,
   * hover effects, etc.
   *
   * Useful to create a more
   * "embedded" looking card
   */
  isBackgroundHidden: _propTypes.default.bool,

  /*
   * URL to organizer profile image.
   * Defaults to random super crop
   */
  imageUrl: _propTypes.default.string,

  /*
   * Boolean determining if card should animate
   * "out" when follow occurs.
   *
   * Useful for if in an array of organizers
   * and want to show more orgs to follow after
   * a given Org is followed
   */
  isHiddenWhenFollowed: _propTypes.default.bool,

  /*
   * Boolean if 'X' button appears on card
   * allowing the user to dismiss this card.
   *
   * Useful for if in an array of organizers
   * and want to allow user to dismiss a given org
   */
  isClosable: _propTypes.default.bool,

  /*
   * Callback for when close button is clicked
   */
  onClose: _propTypes.default.func,

  /*
   * -- Legacy do not use --
   * Callback on onClose before animation finishes running
   */
  onExcludeOrganizer: _propTypes.default.func,

  /*
   * If passed will render "5 upcoming events" as
   * the default custom data point
   */
  numUpcomingEvents: _propTypes.default.number,

  /*
   * If passed will render "5 followers" as
   * the second default custom data point
   */
  numFollowers: _propTypes.default.number,

  /*
   * String rendered underneath organizer name
   * Should provide context and information about
   * the organizer.
   * Takes precedence over numFollowers and numUpcoming events.
   *
   * eg. "Followed by 20 users"
   */
  customDataPoint: _propTypes.default.string,

  /*
   * If true, it won't show the default message whenever the
   * other data points are not available. This is false by default.
   */
  shouldHideDefaultDataPoint: _propTypes.default.bool,

  /*
   * Sample of an event by this organizer
   * to render underneath the card
   * providing additional context to the user
   */
  sampleEvent: _propTypes.default.shape({
    formattedDate: _propTypes.default.string,
    name: _propTypes.default.string
  }),

  /*
   * Callback for when user clicks to view
   * organizer profile.
   */
  onViewOrganizer: _propTypes.default.func,

  /*
   * Indicates if we want to show the solitary button, meaning
   * that the follow button will be the primary CTA in the page.
   * False by default
   */
  isSolitary: _propTypes.default.bool
});

_defineProperty(FollowCard, "defaultProps", {
  isHiddenWhenFollowed: false,
  shouldHideDefaultDataPoint: false,
  isClosable: false,
  isFollowing: null,
  isSolitary: false
});